import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { CurrentUserService } from '@core/services/current-user.service';

import { Tax1099Status } from '@features/profile/models/profile.enum';

import { IconComponent, IconName } from '../icon/icon.component';

export interface BottomNavTab {
  label: string;
  icon: IconName;
  route: string;
}

/**
 * Mobile bottom navigation (plan §11). Hidden on viewports ≥1024px via CSS.
 * Renders a dot on the Profile tab when 1099 action is required or a
 * material T&C update needs re-acceptance.
 */
@Component({
  selector: 'app-bottom-nav',
  standalone: true,
  imports: [IconComponent, RouterLink, RouterLinkActive],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './bottom-nav.component.html',
  styleUrl: './bottom-nav.component.scss'
})
export class BottomNavComponent {
  readonly tabs = input<BottomNavTab[]>([]);

  protected readonly currentUser = inject(CurrentUserService);

  protected readonly showProfileDot = computed(
    () =>
      this.currentUser.tax1099Status() === Tax1099Status.Required ||
      this.currentUser.tcGate()?.requiresReAcceptance === true
  );
}
